import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Context } from 'src/app/shared/models/context';
import { Message, Payment, Salary, SalarySlip } from 'src/app/shared/models/domain';
import { CommonService } from 'src/app/shared/services/common.service';
import { EmployeeService } from 'src/app/shared/services/employee.service';

@Component({
  selector: 'app-payment-crud',
  templateUrl: './payment-crud.component.html',
  styleUrls: ['./payment-crud.component.scss'],
})
export class PaymentCrudComponent implements OnInit {
  @Input() payment: Payment;
  @Input() context: Context;
  @Input() payments: Payment[] = [];
  @Input() sid: number;
  @Input() salaryDate: Salary;
  public paymentModes: string[] = [];
  public formattedDate: string;
  // public salaryDate: string;
  public paymentForm: FormGroup;
  public salarySlip: SalarySlip;
  public salarySummary: SalarySlip;
  public submitted: boolean = false;
  private modified: boolean = false;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private commonService: CommonService,
    private employeeService: EmployeeService,
    private datePipe: DatePipe,

  ) { }

  ngOnInit(): void {    
    this.setPaymentForm(this.payment);
    if (this.payment?.salaryDate) {
      this.formattedDate = this.datePipe.transform(this.payment?.salaryDate, 'dd-MM-yyyy');
      this.getSalarySummary(this.sid, this.formattedDate);
    }
    this.employeeService.getPaymentModes().subscribe((paymentModes) => (this.paymentModes = paymentModes));
    this.paymentForm.get('salaryDate').valueChanges.subscribe(salaryDate => this.salaryDate = salaryDate);
    this.onDateChange();

  }

  public setPaymentForm(payment?: Payment) {
    if (!payment)
      payment = {
        id: null,
        paymentId: "",
        salaryDate: null,
        paymentMode: "ONLINE_PAYMENT",
        referenceId: null,
        remarks: "",
        status: "",
        date: null,
        salaryId: this.sid,
      } as Payment;
    this.paymentForm = this.fb.group({
      id: this.fb.control(payment.id || null),
      date: this.fb.control(this.datePipe.transform(new Date(), 'yyyy-MM-dd'), [Validators.required]),
      paymentMode: this.fb.control(payment?.paymentMode || "ONLINE_PAYMENT", [Validators.required]),
      paymentId: this.fb.control(payment?.paymentId, []),
      salaryId: this.fb.control(payment.salaryId || this.sid, []),
      salaryDate: this.fb.control(this.datePipe.transform(payment.salaryDate, 'yyyy-MM-dd') || this.salaryDate, [Validators.required]),
      remarks: this.fb.control(payment.remarks, []),
      referenceId: this.fb.control(payment.referenceId, []),
      status: this.fb.control(payment.status, []),
    });
    this.paymentForm.valueChanges.subscribe(value => this.modified = true);
  }

  get f() {
    return this.paymentForm.controls;
  }

  public savePayment(inProgress?: any) {
    this.submitted = true;
    if (this.paymentForm.valid) {
      let payment = this.paymentForm.value as Payment;
      payment.status = "DONE";
      this.modified = true;
      if (!this.modified) {
        this.activeModal.close(false);
        this.commonService.setToastr(200, `Payment has been updated successfully!`);
        return;
      }
      inProgress.value = true;  
      if (payment.id && this.paymentForm.value.date) {
        this.employeeService.updatePayment(payment.id, payment).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.activeModal.close(response);
              this.commonService.setToastr(200, `Payment has been updated successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      } else {
        this.employeeService.createPayment(payment).subscribe({
          next: (response: Message) => {
            if (response) {
              this.activeModal.close(response);
              this.commonService.setToastr(200, `Payment has been created successfully!`);
            } else {
              inProgress.value = false;
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
            }
          },
          error: (error: HttpErrorResponse) => {
            inProgress.value = false;
            this.commonService.setToastr(500, error?.error?.name || error.error);
          },
        });
      }
    }
  }

  public onDateChange(): void {
    const date = this.paymentForm?.get('salaryDate')?.value;
    if (date) {
      this.formattedDate = this.datePipe.transform(date, 'dd-MM-yyyy');
      this.getSalarySummary(this.sid, this.formattedDate);
    }
  }

  private getSalarySummary(sid: number, salaryDate: string) {
    this.employeeService.getSalarySummary(sid, salaryDate).subscribe({
      next: (salarySummary: SalarySlip) => {
        this.salarySlip = salarySummary;
      },
      error: (error: HttpErrorResponse) => {
      }
    });
  }
}



